import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./index.css";
import { queryClient, router } from "./router";

const container = document.getElementById("root");
if (!container) throw new Error("#root not found");

createRoot(container, {
  onCaughtError: (error, info) => {
    console.error("Caught error", error, info);
  },
  onUncaughtError: (error, info) => {
    console.error("Uncaught error", error, info);
  },
}).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
